import * as React from 'react';
import RadioGroupContext from './RadioGroupContext';
export default function useRadioGroup() {
  return React.useContext(RadioGroupContext);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/RadioGroup/useRadioGroup.js
// module id = 849
// module chunks = 13